import elementLocaleEN from "element-react/src/locale/lang/en";

const en = {
  translation: {
    // ------- Sidebar
    home: "Home",

    companyOperations: "Company",
    companyDefine: "Company Define",
    companyCreate: "Company Define",
    companyList: "Company List",
    companyEdit: "Company Edit",

    membershipOperations: "Membership",
    membershipMembers: "Members",
    members: "Members",
    activationcreate: "Add New Member",
    membershipActivationcreate: "Add New Member",
    membershipActivationList: "Activations",
    activationList: "Add New Member",
    activations: "Activations",
    membershipActivations: "Activations",
    activationLinkCopy: "Copy activation link",

    definitions: "Definitions",
    offices: "Offices",
    office: "Offices",
    aOffice: "Office",
    sectors: "Sectors",
    location: "Location",
    locations: "Locations",
    skill: "Skill",
    skills: "Skills",
    meetingRoomCategories: "Meeting Room Categories",
    meetingroomcategories: "Meeting Room Category",
    meetingRoom: "Meeting Rooms",
    meetingroom: "Meeting Room",
    addImage: "Add Image",

    reservation: "Reservation",
    networking: "Networking",

    settings: "Settings",

    // ------- Roles
    member: "Member",
    memberAdmin: "Member Admin",
    systemAdmin: "System Admin",

    // ------- Global
    default: "Default",
    kosocial: "Kosocial",
    continue: "Continue",
    companyType: "Company Type",
    pleaseToggleMenu: "You can expand the menu for the sub items.",
    id: "ID",
    other: "Other",
    pickARange: "Pick a range",
    pleaseAddData: "Please press button to add {{type}} data!",
    createdDate: "Created Date",
    lastModifiedDate: "Last Modified Date",
    edit: "Edit",
    create: "Create",
    delete: "Delete",
    active: "Active",
    inactive: "Inactive",
    removed: "Removed",
    emptyData: "No Records Found",
    defineType: "{{type}} Define",
    errorGettingDataList:
      "An error occurred getting the {{type}} list. Please try again later",
    errorGettingData:
      "An error occurred getting the {{type}} data. Please try again later",
    errorInvalidUsernameOrPassword: "Invalid username or password",
    loading: "Loading...",
    search: "Search",
    ok: "OK",
    message: "Message",
    noData: "No matching data for your filters",
    cancel: "Cancel",
    deleteWarningText: "Will be permanently deleted. Do you confirm?",
    deleteWarningTextCard: "Will be permanently deleted. Do you confirm?",
    warning: "Warning",
    error: "Error",
    success: "Success",
    save: "Save",
    saved: "Saved",
    userName: "User Name",
    user: "User",
    monday: "Monday",
    tuesday: "Tuesday",
    wednesday: "Wednesday",
    thursday: "Thursday",
    friday: "Friday",
    saturday: "Saturday",
    sunday: "Sunday",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",
    sun: "Sun",
    day: "Days",
    loadMore: "Load More",
    about: "About",
    hour: "Hour",
    and: "And",
    all: "All",
    today: "Today",
    tomorrow: "Tomorrow",
    thisWeek: "This Week",
    thisMonth: "This Month",
    welcomeMessage: "Welcome {{name}}!",
    successSave: "{{type}} definition was successfully completed.",
    successEdit: "{{type}} changes was successfully completed.",
    successDelete: "{{type}} changes was successfully completed.",
    unknownErrorOccurred: "Unknown error occurred. Please try again later.",
    typeDeleted: "{{type}} Deleted",
    unassigned: "Unassigned",
    noDataYet: "No data available yet",
    new: "New",

    // ------- Auth
    oneClickAwayInTheFamily: "The rest of the family is just a click away...",
    signInToYourAccount: "Sign in",
    email: "E-mail",
    typeYourEmail: "Type your email",
    password: "Password",
    confirmPassword: "Confirm Password",
    typeYourPassword: "Type your password",
    reTypeYourPassword: "Re-type your password",
    urlInvalid: "Please enter a valid url",
    signIn: "Sign in",
    forgotPassword: "Forgot password",
    language: "Language",
    english: "English",
    turkish: "Türkçe",
    privacyTermsLabel:
      "By logging in you agree to our privacy & terms of service.",
    noWorries:
      "No worries! Just enter your e-mail and we’ll send you login instructions",
    sendMeInstructions: "Send Me Instructions",
    goToBack: "Back",
    activation: "Activation",
    justOneClick: "You're just a few steps away from becoming a family member!",
    savePassword: "Save Password",
    helpIsOnTheWay: "Help Is On The Way!",
    helpIsOnTheWayLabel:
      "If there is an active user for the e-mail address you specified, an e-mail containing a password change link will be sent to you.",
    logout: "Logout",
    passwordCharacterLengthFail:
      "The Password must be at least 8 characters long.",
    passwordDigitFail: "Passwords must have at least one digit.",
    passwordAzFail: "Passwords must have at least one uppercase/lowercase.",
    passwordsNotMatch: "Passwords not match.",
    errorWhileSigning: "An error occurred while signing.",
    checkYourEmail: "Please check your email!",

    // ------- Company
    companies: "Companies",
    team: "Team",
    companiesNewComers: "New Networking Companies",
    teamNewComers: "New Members",
    corporatePersonalInformation: "Corporate/Personal Information",
    personal: "Personal",
    companyName: "Company Name",
    companyLogoAdd: "Add Logo",
    businessType: "Business Type",
    sector: "Sector",
    abilities: "Abilities",
    companyLogo: "Company Logo",
    companyBio: "Company Bio",
    status: "Status",
    reserveCapacity: "Meeting Room Reservation Capacity",
    capacityExceedingSwitch:
      "If the capacity is exceeded, can you continue the meeting room reservation?",
    appearKoDirectory: "Would you like to appear Company in Networking?",
    send: "Send",
    sapID: "Sap ID",
    sapCompanyName: "SAP Company Name",
    freelancer: "Freelancer",
    startup: "Startup",
    VC: "VC / Investor",
    corporateBT: "Corporate",
    agency: "Agency / Boutique Company ",
    addCompanyLogo: "Add Company Logo",
    isEmployeesVisibleInKoDirectory: "Is Employees Visible In Networking?",
    isPassDebitCard: "Prepaid or Foreign Card Check?",
    isNewOfficeDistribute: "When a new office is added, should it be added to all members?",
    nomad: "Nomad",
    virtualWithoutUsage: "Virtual Without Usage",
    virtualWithUsage: "Virtual With Usage",
    privateOffice: "Private Office",
    fixedDesk: "Fixed Desk",
    MeetingRoomMembership: "Meeting Room Membership",
    meetingroommembership: "Meeting Room Membership",
    membershipType: "Membership Type",
    membershipInfo: "Membership Information",
    deleteMember: "Delete Member",
    country: "Country",
    taxId: "Tax Id",
    taxOffice: "Tax Office",

    // ------- Definitions
    locationsList: "Location List",
    locationDefine: "Define Location",
    locationCreate: "Define Location",
    locationsDefine: "Define Location",
    locationsCreate: "Define Location",
    locationEdit: "Location Edit",
    locationsEdit: "Location Edit",
    locationName: "Location Name",

    skillList: "Skill List",
    skillsList: "Skill List",
    skillDefine: "Define Skill",
    skillCreate: "Define Skill",
    skillsDefine: "Define Skill",
    skillsCreate: "Define Skill",
    skillEdit: "Skill Edit",
    skillsEdit: "Skill Edit",
    skillName: "Skill Name",

    officeList: "Office List",
    officeDefine: "Define Office",
    officeCreate: "Define Office",
    officeEdit: "Office Edit",
    officeName: "Office Name",
    sapOfficeName: "SAP Office Name",
    sapCapacity: "SAP Capacity",

    sectorList: "Sector List",
    sectorsList: "Sector List",
    sectorDefine: "Define Sector",
    sectorCreate: "Define Sector",
    sectorsDefine: "Define Sector",
    sectorsCreate: "Define Sector",
    sectorEdit: "Sector Edit",
    sectorsEdit: "Sector Edit",
    sectorName: "Sector Name",

    meetingRoomCategoriesList: "Meeting Room Categories List",
    meetingroomcategoriesList: "Meeting Room Categories List",
    meetingRoomCategoryDefine: "Define Meeting Room Category",
    meetingRoomCategoryCreate: "Define Meeting Room Category",
    meetingroomcategoriesDefine: "Define Meeting Room Category",
    meetingroomcategoriesCreate: "Define Meeting Room Category",
    meetingRoomCategoryEdit: "Meeting Room Category Edit",
    meetingroomcategoriesEdit: "Meeting Room Category Edit",
    meetingRoomCategoryName: "Meeting Room Category Name",
    meetingRoomCategoriesName: "Meeting Room Categories Name",

    meetingRoomList: "Meeting Rooms List",
    meetingroomList: "Meeting Rooms List",
    meetingRoomDefine: "Define Meeting Room",
    meetingRoomCreate: "Define Meeting Room",
    meetingroomDefine: "Define Meeting Room",
    meetingroomCreate: "Define Meeting Room",
    meetingRoomEdit: "Meeting Room Edit",
    meetingeoomEdit: "Meeting Room Edit",
    meetingRoomName: "Meeting Room Name",
    cannotDeleteLastImage:
      "This field is required. You can not delete last image.",
    pleaseFillRequiredField: "Please fill all required fields",

    isUsingRadius: "Is using Radius?",
    radiusUsername: "Radius Username",
    radiusServer: "Radius Server",
    radiusDatabase: "Radius Database",
    radiusPassword: "Radius Passsord",

    perkscategory: "Perks Categories",
    Perkscategory: "Perks Categories",
    PerksCategory: "Perks Categories",
    perkscategoryList: "Perks Category List",
    perksCategoryDefine: "Define Perks Category",
    perkscategoryCreate: "Define Perks Category",
    perksCategoryName: "Perks Category Name",
    koPerksCategoryName: "Perks Category Name",
    perkscategoryEdit: "Edit Perks Category",

    perks: "Perks",
    perksList: "Perks List",
    perksDefine: "Define Perks",
    perksCreate: "Define Perks",
    perksName: "Perks Name",
    koPerksName: "Perks Name",
    perksEdit: "Edit Perks",
    perksOffer: "Offer",
    koPerksOffer: "Offer",
    expireDate: "Expire Date",

    perksSearch: "Perks Search",
    perksCategorySearch: "Category",
    perksCaptureOffer: "See The Deal",
    similarPerks: "Similar Perks",
    detail: "Detail",
    onboardingNotificationEmail: "New Member Notification Mail Addresses",
    nodataPerks: "Perks not found!",
    howDoUse: "How Do I Use?",

    // ------- Meeting Room Define
    meetingRoomDefineName: "Name",
    meetingRoomSummary: "Brief Description",
    meetingRoomAdminMessage: "Only System Administrators can make reservations",
    reservationTimeInterval: "Reservation Time Interval",
    minimumMeetingDuration: "Minimum Meeting Duration",
    maximumMeetingDuration: "Maximum Meeting Duration",
    cancellationDuration: "Cancellation Duration",
    maximumDaysForReservationInFuture: "Days for Reservation Limit",
    cleaningDuration: "Meeting Room Cleaning Time",

    // ----- Question Category

    questioncategory: "Question Categories",
    questioncategoryList: "Question Category List",
    questionCategoryDefine: "Queestion Category",
    questioncategoryCreate: "Question Category Define",
    questionCategory: "Question Category",
    questionCategoryName: "Question Category Name",
    questioncategoryEdit: "Question Category Edit",

    // ----- Question

    question: "Questions",
    questionList: "Question List",
    questionDefine: "Question",
    questionCreate: "Question Create",
    questionName: "Question",
    questionEdit: "Question Edit",
    lblAnswers: "Answers",
    answer: "Answer",
    newAnswer: "Add New Answer",
    sortOrder: "Sort Order",
    waitingDay: "Waiting Day",

    // ----- Message
    messageList: "Message List",
    messageDefine: "Message",
    messageCreate: "Message Define",
    endDate: "Start Date",
    priority: "Priority",
    messageType: "Message Type",
    isActionRequired: "Action Required?",
    messageViewType: "View Type",
    viewType: "View Type",
    messageEdit: "Message Edit",

    // ----- Notification Widget
    payNow: "Pay Now",
    notifications: "NOTIFICATIONS",
    thanksforYourFeedback: "Thanks for your feedback",
    notificationEmpty: "Great, you read all the notifications!",
    notification: "Notifications",
    readMore: "Read More",
    readLess: "Read Less",

    week: "Week",
    month: "Month",
    lastWeek: "Last Week",
    lastMonth: "Last Month",
    last3Months: "Last 3 Months",
    saltoLockName: "Salto Lock",
    saltoLock: "Salto Lock",
    color: "Color",
    capacity: "Capacity",
    guestCapacity: "Guest Capacity",
    pricing: "PRICING",
    priceForHour: "Price TRY",
    taxRatio: "Tax Ratio (KDV)",
    startTime: "Start Time",
    endTime: "End Time",

    // ------- Membership
    activationSuccess: "Your account has activate successfully",
    sentConfirmationLink:
      "We sent the activation link to the user's email address.",
    resendConfirmation: "Resend activation link",
    emailConfirmed: "Activation",
    confirmed: "Confirmed",
    notConfirmed: "Not Confirmed",
    hasActivation: "Activated",
    hasntActivation: "Send activation link",
    completeActivation: "Complete Activation",
    createPassword: "Create Password",
    yourName: "Your name",
    yourLastname: "Your lastname",
    yourGender: "Your gender",
    yourAgeRange: "Your age range",
    personalInfo: "Personal Information",
    generalInfo: "General Information",
    paymentInfo: "Payment Information",
    name: "Name",
    lastName: "Lastname",
    lastname: "Lastname",
    gender: "Gender",
    man: "Man",
    woman: "Woman",
    none: "I do not want to specify",
    ageRangeName: "Age Range",
    ageRange: "Age Range",
    phoneNumber: "Phone Number",
    shortBio: "About",
    company: "Company",
    definedOfficesToCompany: "Defined Offices To Company",
    role: "Role",
    social: "Social Media",
    linkedInUrl: "LinkedIn URL",
    instagramUrl: "Instagram URL",
    facebookUrl: "Facebook URL",
    twitterUrl: "Twitter URL",
    roles: "Roles",
    title: "Title",
    membershipDefine: "Employee or Member Define",
    membershipCreate: "Employee or Member Define",
    membershipEdit: "Membership Edit",
    membershipList: "Membership List",
    myProfile: "My Profile",
    myprofile: "My Profile",
    updateCompanyPicture: "Update Company Picture",
    updateUserPicture: "Update User Picture",
    resetPassword: "Change Password",
    resetpassword: "Change Password",
    currentPassword: "Current Password",
    newPassword: "New Password",
    newPasswordConfirm: "New Password Confirm",
    isAccountOwner: "Is Account Owner?",
    printerCode: "Printer Code",
    saltoId: "Salto ID",
    systemAdminCreateAlertMessage:
      "You're adding 'System Administrator', are you sure?",
    checkOutDate: "Check Out Date",
    // ------- Settings
    meetingRoomAccessStartTime:
      "How much time do you have at the reservation time?",
    meetingRoomAccessEndTime:
      "How long after the reservation time is the doors closed?",
    meetingRoomReservationInterval: "Reservation time interval",
    isRadiusServerEncryption:
      "Does the wifi radius server use an encrypted password?",

    membershipSegments: "Segments",
    segments: "Segments",
    userSegmentName: "Segment Name",
    userSegment: "Segment",
    userSegmentDefine: "Segment Create",
    filterType: "Filter Type",
    "membershipSegment-create": "Segment Create",
    "membershipSegment-edit": "Segment Edit",
    membershipFillMonthFilter: "Members Who Complete X Month (Ex. 3)",
    //Enum FilterTypes
    allMemberships: "All Members",
    customFilter: "Custom Filtre",
    ticketResolved: "Resolved Ticket",
    eventParticipants: "Participants to Events",
    invoiceUnPaid: "Non-Payment Invoices",
    csvImport: "Csv Import",
    //

    birthday: "Birthday",
    birthdayUpcoming: "Upcoming birtdays (0=Today, 1=Yesterday)",
    isEventParticipations: "Participants in the Event",
    eventParticipation: "Participated Events",
    isOverMeetingRoomBooking: "Members Using More Meeting Rooms",
    useMeetingRoomRate: "Meeting Room Usage (Hours)",

    // ------- KoDirectory
    noTeamData: "No team in {{company}}.",
    CompanyTeam: "{{companyName}}'s team",
    contacts: "Contacts",
    memberProfile: "Team Profile",
    memberprofile: "Team Profile",
    companyProfile: "Company Profile",
    companyprofile: "Company Profile",
    seeAllResults: 'See all results for "{{query}}"',
    kodirectorySearch: "Search in Persons, Companies, Skills, Sectors",
    allResults: "All Results",

    // ------- Charts
    upcomingReservations: "Upcoming Reservations",
    shortMinute: "m",
    longMinute: "Minute",
    shortHour: "h",
    longHour: "Hour",
    noUpcomingReservations: "No upcoming reservation",
    debtBalance: "Debt Balance",
    lastInvoiceAmount: "Last Invoice Amount",
    teamSize: "Member Capacity",
    meetingRoomOccupancyRate: "Meeting Room Occupancy Rate",
    totalNumberOfMembers: "Total Number Of Members",
    numberOfOutgoingMembers: "Number Of Outgoing Member",
    numberOfNewComers: "Number Of New Comers",
    paidMeetingRoomRevenue: "Paid Meeting Room Revenue",
    numberOfMembers: "Total Number Of Members",

    // ------- Reservations
    bookingCapacityExceeded:
      "You will be charged extra for this booking, as there is no free reservation right.",
    myReservations: "Meeting Room Reservations",
    myreservations: "Meeting Room Reservations",
    reservations: "Reservation",
    reservationCalendar: "Meeting Room Reservation Calender",
    reservationcalendar: "Meeting Room Reservation Calender",
    newBooking: "Create new booking",
    newbooking: "Create new booking",
    editBooking: "Edit booking",
    editbooking: "Edit booking",
    selectMeetingRoom: "Select Meeting Room",
    peopleToAttendTheMeeting: "People To Attend The Meeting",
    writeATitle: "Meeting Title",
    note: "Note",
    bookNow: "Book Now",
    startDate: "Start Date",
    duration: "Duration",
    pickADate: "Pick A Date",
    pickATime: "Pick A Time",
    pickADuration: "Pick A Duration",
    errorGettingFreeReservationCredit:
      "Your company's remaining free reservation credit could not be found",
    remainingFreeReservationCredit: "remaining free reservation duration",
    deletedBooking: "Your booking has been deleted",
    reservationDate: "Date",
    time: "Hours",
    monthlyFreeLimit: "MONTHLY FREE LIMIT",
    freeUse: "FREE USE",
    freeRemaining: "FREE REMAINING",
    paidUse: "PAID USE",
    freeRemainingTransferMessage:
      "The remaining reservation hours cannot be transferred to the following months.",
    requestOrSuggestion: "Request/Suggestion",
    complaint: "Complaint",
    ticketType: "Ticket Type",

    // Guest Reservations

    Guestreservations: "Guest Reservations",
    guestreservations: "Guest Reservations",
    numberOfGuest: "Number of Guest",
    reservationDateTime: "Reservation Date",
    locationGuest: "Guest Reservation",
    locationGuestDefine: "Guest Reservation Define",
    pleaseSelectDate: "Please select date!",
    pleaseSelectHour: "Please select Hour!",
    pleaseSelectLocation: "Please select location!",
    selectLocation: "Select location",
    selectHour: "Select hour",
    guests: "GUESTS",
    guestNameLastname: "Guest name and lastname",
    pleaseInputGuestNameLastname: "Please input guest name and lastname!",
    addGuest: "Add Guest",
    person: "person",
    entryButton: "Entry",
    outButton: "Exit",
    outed: "Exited",
    entered: "Entered",
    list: "My Guests",
    calendar: "Guest Reservation Calendar",

    // ------- Tickets
    noDescription: "No description",
    feedbackScore: "Point",
    solutionUserName: "Contact Person",
    thanks: "Thank You!",
    goToKoplanet: "Go To OfficeLink",
    feedbackTitle: "Get OfficeLink",
    feedbackDescription:
      "Improvements and feedback are very valuable to us, you can leave them below.",
    ticketSave:
      "We have received your ticket and we're on it. We'll update you as soon as possible.",
    ticket: "Support",
    media: "Media",
    demandList: "Demand List",
    demandlist: "Demand List",
    myTickets: "My Support Requests",
    mytickets: "My Support Requests",
    assignedMe: "Assigned Me",
    assigntome: "Assigned To Me",
    assignedtome: "Assigned To Me",
    allTickets: "All Support Requests",
    alltickets: "All Support Requests",
    usagereport: "Usage Report",
    Usagereport: "Usage Report",
    createNewTicket: "Please click the button to create a new support request.",
    categoryName: "Category Name",
    categoryParent: "Parent Category",
    categoryChild: "Child Category",
    ticketTitle: "Title",
    description: "Description",
    noTicket: "There is no support request yet",
    solution: "Solution",
    processing: "Processing",
    responsiblePersons: "Responsible Persons",
    ticketCategory: "Support Category",
    ticketcategory: "Support Category",
    ticketCategories: "Support Categories",
    ticketcategories: "Support Categories",
    ticketCategoriesName: "Category Name",
    ticketCategoryDefine: "Define Support Category",
    ticketCategoryCreate: "Define Support Category",
    ticketcategoryDefine: "Define Support Category",
    ticketcategoryCreate: "Define Support Category",
    ticketCategoryEdit: "Support Category Edit",
    ticketcategoryEdit: "Support Category Edit",
    ticketCategoryList: "Support Category List",
    ticketcategoryList: "Support Category List",
    ticketCategoryName: "Category",
    ticketCategoryAssignUserList: "Ticket Category Assign User List",
    ticketcategoryassignuser: "Ticket Category Assign User",
    ticketcategoryAssignUserDefine: "Define Support Category Assign User",
    ticketCategoryAssignUser: "Responsible peoples",
    isSolved: "Status",
    isSolved_false: "In Processing",
    isSolved_true: "Completed",
    inProcessing: "In Processing",
    completed: "Completed",
    ticketEdit: "Support Request Edit",
    createTicket: "Create Support Request",
    reservationEditWarning:
      "This reservation can only be arranged {{cancellationDuration}} before the start time.",
    meetingRoomLockOpenMessage:
      "You can open the meeting room door {{meetingRoomAccessStartTime}} minutes before the reservation time.",
    participant: "Participant(s)",
    deleteReservation: "Delete Booking",
    close: "Close",
    bookingDeleted: "Booking deleted",
    myBookings: "My Bookings",
    bookFewSteps: "Book a meeting room in a few steps.",
    successBooking: "Your booking has been successfully created.",
    successBookingEdit: "Your booking has been successfully updated.",
    reservationUpdated: "Booking Updated",
    reservationCreated: "Booking Created",
    congratulations: "Congratulations",
    ticketStatus: "Status",
    Waiting: "Waiting",
    Solved: "Solved",
    UnSolvable: "Unsolvable",
    userInfo: "User Info",
    solutionUser: "Contact Person",
    solutionDate: "Solution Date",
    relatedTicketCategory: "Releted Category",
    relatedTicketCategories: "Releted Categories",
    comments: "Comments",
    commentPlaceholder: "Ask a question or inquire about your request...",
    comment: "Comment",
    // ------- Payment
    ödendi: "Paid",
    ödenmedi: "UnPaid",
    date: "Date",
    financial: "Financial Operations",
    creditCards: "Credit Cards",
    creditcards: "Credit Cards",
    invoiceExtract: "Invoice Extract",
    invoiceextract: "Invoice Extract",
    creditCard: "Credit Card",
    creditCardList: "Credit Cards",
    creditcardlist: "Credit Cards",
    automaticPayment: "Automatic Payment",
    automaticpayment: "Automatic Payment",
    myCreditCards: "Credit Cards",
    mycreditcards: "Credit Cards",
    isDefault: "Use Automatic Payment",
    creditCardDefine: "Credit Card Define",
    creditcardcreate: "Credit Card Define",
    cardAlias: "Card Name",
    expirationDate: "Expiration Date",
    cvc: "CVC",
    debitCardMessage:
      "Only credit card must be defined. Debit and prepaid cards are not valid for direct debit.",
    debitCardInvoiceMessage:
      "You can pay your bill with debit and prepaid cards. But, these cards are not registered for later use.",
    safelyStoredByIyzico1: "Your personal data is safely stored by",
    safelyStoredByIyzico2: "iyzico system.",
    safelyStoredByIyzico3: "and saved for automatic payment.",
    creditCardDeleteOrEditWarning:
      "Deleting registered credit cards or making changes to card information can only be done by the OfficeLink team.",
    deselect: "Deselect",
    selectAll: "Select All",
    removeAll: "Remove All",
    loadingInvoice: "Loading Invoice",
    errorLoadingInvoice: "Invoice not loaded",
    approveUserAgreement1: "I have read and approve the",
    approveUserAgreement2: "user agreement.",
    approveUserAgreement3: "",
    clickForDefineToCreditCard: "Please click to add a new credit card.",
    approveIyzicoSystem1: "I approve my credit card information with",
    approveIyzicoSystem2: "iyzico system.",
    approveIyzicoSystem3: "",
    iyzicoSystemTooltipMessage:
      "All credit cards and information that you register in the system are securely stored by Iyzico with PCI-DSS Level 1 certificate.",
    definedCards: "Defined Cards",
    paymentSuccess: "Payment successfully completed",
    payableInvoiceAmount: "Payable Invoice Amount",
    invoiceDetails: "Invoice Details",
    invoicedetails: "Invoice Details",
    gettingCardList: "Getting credit cards list",
    exceed2MB: "Image size can not exceed 2MB.",
    docDate: "Invoice Date",
    documentNumber: "Invoice No",
    paidAmount: "Paid Amount",
    unPaidAmount: "Unpaid Amount",
    billStatus: "Status",
    invoice: "Invoice",
    view: "View",
    Paid: "Paid",
    paid: "Paid",
    UnPaid: "UnPaid",
    unpaid: "Unpaid",
    InsufficientBalance: "Insufficient Balance",
    insufficientBalance: "Insufficient Balance",
    AwaitingPayment: "Awaiting Payment",
    awaitingPayment: "Awaiting Payment",
    paymentType: "Payment Method",
    aCreditCardRequired:
      "You need to define a credit card to continue the process.",
    startAutomaticPayment: "Make Payment",
    selectedCardUseForAutoPayment:
      "The card you select is used for automatic payment",
    noDataForAutoPayment: "There is no invoice for automatic payment.",
    noDataCreditCard: "No credit card defined in the system yet.",
    selectAutomaticPaymentCard:
      "You have successfully determined the credit card to be used for automatic payment.",
    documentAmount: "Document Amount",
    AFewMin: "This process may take a few minutes",
    payByAnotherCreditCard: "Pay by another card",
    paymentStatusMessage: "Auto Payment Status",
    autoPaymentChangeText:
      "Automatically withdraw invoices from the default credit card at the beginning of each month?",

    // ------- Event
    event: "Event",
    eventCategory: "Event Category",
    eventcategory: "Event Category",
    eventCategoryList: "Event Category List",
    eventcategoryList: "Event Category List",
    eventCategoryDefine: "Define Event Category",
    eventCategoryCreate: "Define Event Category",
    eventcategoryDefine: "Define Event Category",
    eventcategoryCreate: "Define Event Category",
    eventCategoryEdit: "Event Category Edit",
    eventcategoryEdit: "Event Category Edit",
    eventDetails: "Event Details",
    events: "Events",
    eventList: "Event List",
    eventlist: "Event List",
    eventCalendar: "Event Calendar",
    eventcalendar: "Event Calendar",
    participantList: "Participants",
    participantlist: "Participants",
    eventCategoryName: "Event Category Name",
    icon: "Icon",
    eventDefine: "Define Event",
    eventCreate: "Define Event",
    eventEdit: "Event Edit",
    eventName: "Event Title",
    eventPlace: "Event Place",
    planner: "Planner",
    url: "Url",
    eventCapacity: "Event Capacity",
    backupCapacity: "Backup List Capacity",
    showEventWeb: "Show the event in the web?",
    aPaidEvent: "A Paid Event?",
    price: "Price",
    currency: "Currency",
    eventCancellationDuration: "Event Cancellation Duration",
    eventLocationType: "Location Type",
    internalLocation: "Internal Location",
    externalLocation: "External Location",
    detailInfo: "Details",
    upcomingEvents: "Upcoming Events",
    gridView: "Grid View",
    listView: "List View",
    nodataUpcomingEvent: "No upcoming event.",
    showAllEvents: "Show All Events On Calendar",
    eventDateTime: "Event Date",
    joinEvent: "Join Event",
    quotaFull: "Capacity Full",
    joinBackupList: "Join Backup List",
    leaveBackupList: "Leave Backup List",
    giveUpFromJoin: "Leave Join",
    expired: "Time Expired",
    eventCancelWarning:
      "Participation to paid events can be cancelled 1 hour before start time",
    similarEvents: "Similar Events",
    free: "Free",
    noDataAvailableEvent: "No Events Found.",
    deleteIsDefaultCard:
      "This card is defined for automatic payments. If you want to delete, you can define another card for direct debit",

    // Digital Membership
    pleaseInputYourName: "Please input your name!",
    pleaseInputYourLastname: "Please input your lastname!",
    pleaseInputEmail: "Please input your email!",
    membership: "Membership",
    invoiceDetail: "Invoice Detail",
    payment: "Payment",
    nameLastname: "Name Lastname",
    identityNumber: "Identity Number",
    identityOrPassportNumber: "Identity or Passport Number",
    address: "Address",
    individual: "Individual",
    corporate: "Corporate",
    pleaseInputCompanyName: "Please input company name!",
    pleaseInputNameLastname: "Please input name lastname!",
    pleaseInputIdentityNumber: "Please input identity number!",
    pleaseInputAddress: "Please input address!",
    vatOffice: "Vat Office",
    pleaseInputVatOffice: "Please input vat office!",
    vatNumber: "Vat Number",
    pleaseInputVatNumber: "Please input vat number!",

    cardHolderName: "Credit Card Holder Name",
    pleaseInputCardHolderName: "Please input credit card holder name!",
    cardNumber: "Credit Card Number",
    pleaseInputCardNumber: "Please input credit card number!",
    cardMonth: "Month",
    pleaseInputCardMonth: "Please select month!",
    cardYear: "Year",
    pleaseInputCardYear: "Please select year!",
    cardCvc: "CVC",
    pleaseInputCardCvc: "Please input cvc!",
    maximumCharacterLimit4: "Maximum character limit is 4!",
    maximumCharacterLimit10: "Maximum character limit is 10!",
    maximumCharacterLimit11: "Maximum character limit is 11!",
    minimumCharacterLimit3: "Minimum character limit is 3!",
    minimumCharacterLimit10: "Minimum character limit is 10!",
    minimumCharacterLimit11: "Minimum character limit is 11!",
    subscriptionMonth: "mo",
    pleaseCheckAgreement: "Please accept the agreement!",
    cardDistanceSalesContract: "Distanse Sales Agreement",
    cardPreliminaryInformationFormContract: "Preliminary Information Form",
    cardAgreement: "I have read and approved the {{cardDistanceSalesContract}}.",
    cardAgreementVirtualOffice: "I have read and approved the {{cardDistanceSalesContract}} and the {{cardPreliminaryInformationFormContract}}.",
    cardAgreementNomad: "I have read and approved the {{cardDistanceSalesContract}} and the {{cardPreliminaryInformationFormContract}}.",
    pay: "Pay {{price}} TRY ",
    digitalMemberShipTitle:
      "Start your online membership now!",
    vat: "VAT",
    pleaseSelectPeriod: "Please select period!",
    period: "Period",
    pleaseSelectProductType: "Please select membership type!",
    welcomeAboard: "Welcome aboard {{name}}",
    digitalMembershipSuccess: "Completed your membership!",
    digitalMembershipSuccessEmail:
      "We sent an activation link to the e-mail address. You can activate your membership from the relevant link.",
    // Daily Pass

    dailypass: "Daily Pass",
    dailyPassCapacity: "Daily Daily Pass Capacity",
    sapId: "Sap Branch Id",
    sapProjectId: "Sap Project Code",
    freeUsageThisMonth: "FREE USAGE THIS MONTH",
    dailypassEmptyData: "Create a Daily Pass",
    dailypasslist: "List",
    payWithDifferenCreditCard: "Pay with Different Credit Cards",
    isSavedCreditCard: "I want my credit card saved for other payments.",
    dailypassPayButtonText: "{{price}} TRY Pay ve Save",
    pleaseSelectCreditCard: "Please select credit card!",
    cancelIt: "Cancel it",
    canceled: "Canceled",
    dailyPassCancelWarningText: "Your Daily Dass will be canceled and added to the free usage right, do you confirm?",
    dailyPassCannotBeCanceled: "Daily Pass reservation can be canceled until one day before the day of use.",
    cancellationDescription: "This Daily Pass reservation cancellation is automatically added to the free usage rights of the relevant month for 1 day.",

    // Daily Pass Check
    find: "Find",

    documentName: "Document Name",
    paperSize: "Paper Size",
    cost: "Amount",
    totalPages: "Total Pages",
    totalColorPages: "Color",
    totalGrayScalePages: "Black White",
    usageDate: "Date",
    pages: "Pages",
    amount: "Amount",
    printerusages: "Printer Usage Report",


    //Report
    reports: "Reports",
    dailypasscheck: "Daily Pass Check",
    fullname: "Member",
    digitalMembership: "Digital Membership",
    reset: "Reset",
    fieldIsRequired: "Bu alan zorunlu",
    choose: "Seçiniz",
    sapGeneralProjectId: "Merkez Sap Proje Kodu",
    true: "Yes",
    false: "No",
    isDigitalMembership: "Digital Membership",
    companyAuthorization: "Company Authorization",

    // Promotion Code
    code: "Promotion Code",
    percentageOfDiscount: "Percentage of Discount",
    promotionCode: "Promotion Code",
    PromotionCode: "Promotion Code",
    promotioncode: "Promotion Code",
    promotioncodeList: "Promotion Code List",
    numberOfUses: "Number of Uses",
    promotioncodeCreate: "Promotion Code Create",
    promotionCcdeCreate: "Promotion Code Create",
    promotioncodeEdit: "Promotion Code Edit",
    used: "Used",
    normal: "Normal",
    FirstMonthIsFree: "First Month is Free",
    FirstMonthIsFreeAfterAutoCancellation: "First Month is Free After Auto Cancellation",
    promotionType: "Promotion Type",

    numberOfPeople: "Number of People",
    isDailyLease: "Is Daily Lease?",
    dailyPrice: "Daily Lease Price",


    dailyrents: "Daily Office Rental",
    dailyrentsDescriptionTitle: "It is now very easy to work in all locations by renting a daily office!",
    dailyrentsDescription: "Choose the office you want to work in below and rent it daily.",
    dailyrentslist: "",
    checkout: "Checkout",
    dailyrentPayButtonText: "{{price}} TRY Pay and Rent Now",
    rentNow: "Rent Now",
    dailyRentSuccessMessage: "Your daily office rental has been successfully completed. You can use your office by going to the location on the relevant date.",
    lastDailyRents: "PREVIOUS RENTALS",
    dailyrentprevious: "Previous Rentals",
    dailyrentreport: "Daily Office Rental Report",
    answerType: "Answer Type",
    answerTypeMessage: "Type a answer...",
    dailyRentNotFoundTitle: "If you can't find a suitable office on the day and criteria you are looking for, consult our membership team.",
    dailyRentNotFoundDescription: "Let's find the most suitable office for you.",
    dailyRentType: "Type",
    sales: "Sales",

    //idea
    idea: "I have an idea",
    ideaPlaceHolder: "You can write your idea here...",
    ideaEmails: "I have an idea e-mail addresses",

    //feedback
    feedbacks: "Feedbacks",
    feedbacksList: "Feedback List",
    feedbackQuestion: "Question",
    feedbacksEdit: "Edit",
    feedbacksCreate: "Create",
    feedbacksRates: "Scores",
    feedback: "Feedback",
    frequency: "Frequency",
    weekly: "Weekly",
    monthly: "Monthly",
    rate: "Score",
    minText: "Description for min",
    maxText: "Descripotion for max",

    newCompanyCreate: "Create New Company",
    newMemberCreate: "Create New Member",
    newSegmentCreate: "Create New Segment",
    newFeedbackCreate: "Create New Feedback",
    newLocationCreate: "Create New Location",
    newOfficeCreate: "Create New Office",
    newSkillCreate: "Create New Skill",
    newMeetingroomCategoryCreate: "Create New Meeting Room Category",
    newMeetingroomCreate: "Create New Meeting Room",
    newTicketCategoryCreate: "Create New Ticket Category",
    newTicketCategoryAssignUserCreate: "Create New Responsible",
    newTicketCreate: "Create New Ticket",
    newEventCreate: "Create New Event",
    newSectorCreate: "Create New Sector",
    newEventCategoryCreate: "Create New Event Category",
    newPerksCreate: "Create New Perks",
    newPerksCategoryCreate: "Create New Perks Category",
    newPromotionCodeCreate: "Create New Promotion Code",
    newDailypassCreate: "Create New Daily Pass",
    newMeetingroomReservasationCreate: "Create New Reservation",
    newGuestReservationCreate: "Create New Guest Reservation",
    newCreditCardCreate: "Create New Credit Card",
    source: "Source",

    // products
    product: "Product",
    definitionsProducts: "Products",
    products: "Products",
    productsEdit: "Edit",
    productsCreate: "Create",
    newProductCreate: "Add New Product",
    shortDescription: "Short Description",
    locks: "Door Locks",
    vatPercentage: "Vat Percentage",
    productType: "Product Type",
    priceType: "Price Type",
    quantity: "Quantity",
    action: "Action",
    prices: "Prices",
    features: "Features",
    timing: "Timing",
    onlineSalesFooterNotFoundTitle: "If you cannot find a suitable office within the criteria you are looking for, you can contact us.",
    onlineSalesFooterNotFoundDescription: "Let's find the most suitable office for you right away.",
    onlineSalesFixedOfficeTitle: "PRIVATE OFFICE",
    onlineSalesFixedOfficeDescription: "Enjoy a comfortable working environment without dealing with details!",
    onlineSalesNomadTitle: "NOMAD",
    onlineSalesNomadDescription: "OfficeLink for whenever you need an office!",
    onlineSalesVirtualOfficeTitle: "VIRTUAL OFFICE",
    onlineSalesVirtualOfficeDescription: "The most prestigious address for your company is OfficeLink Virtual Office.",
    emptyText: "No records found matching the criteria!",
    onlineSalesSuccessTitleWithLogin: "Congratulations, your purchase was successful",
    onlineSalesSuccessDescriptionWithLogin: "You can access your invoice from My Account > Invoices.",
    contactUs: "Contact us",

    // product type
    FixedOffice: "Private Office",
    FixedDesk: "Fixed Desk",
    VirtualOffice: "Virtual Office",
    VirtualOfficeForUsed: "Virtual Office Use",
    Nomad: "Nomad",
    DigitalMembership: "Digital Membership",
    MeetingRoom: "Meeting Room",
    DailyPass: "Day Pass",
    DoorEntryMobileApp: "Door Entry Mobile App",
    PrinterA4Grayscale: "Printer A4 Grayscale",
    PrinterA4Colored: "Printer A4 Colored",
    PrinterA3Grayscale: "Printer A3 Grayscale",
    PrinterA3Colored: "Printer A3 Colored",

    // price type
    General: "General",
    LocationBase: "Location Base",

    createdUser: "Created",
    lastModifiedUser: "Last Modified",
    integrationCode: "Integration Code",

    // contracts

    subscription: "Subscription",
    subscriptionAdd: "Create Subscription",
    subscriptions: "Subscriptions",
    Subscriptions: "Subscriptions",
    membershipSubscriptions: "Subscriptions",
    subscriptionsCreate: "Create",
    subscriptionsEdit: "Edit",
    signDate: "Sign Date",
    CreditCard: "Credit Card",
    BankTransfer: "Bank Transfer",
    Draft: "Draft",
    Active: "Active",
    Ended: "Ended",
    Removed: "Removed",
    paymentRange: "Invoice Frequency",
    youCanOnlyAddPdfFile: "You can only add pdf file.",
    nextRenewalDate: "Renewal Date",

    cancelSubscription: "Cancel Subscription",
    cancelSubscriptionSuccessMessage: "Subscription cancellation request has been received successfully.",
    cancellationDate: "Cancellation Date",
    cancellationInfoMessage: "A cancellation request was received for this subscription on {{cancellationRequestDate}}. This subscription will be terminated on {{cancellationDate}}!",
    cancellationInfoMessageTitle: "Subscription Cancellation Request",
    cancellationRemoveButton: "Delete Cancellation Request",
    subscriptionItemAreYouSureYouWantToDelete: "Since the contract is active, your deletion request will be received and will be automatically deleted on {{renewalDate}}. Do you confirm?",
    updates: "Updates",
    subscriptionItemDelete: "Will be stopped",
    subscriptionItemNew: "Will be added",
    now: "Now",
    onTheRenewalDate: "On Subscription Update Date",
    renewalsTime: "Usage Time",
    addProduct: "Add Product",
    account: "Account",
    invoices: "Invoices",
    invoicePeriod: "Billing Period",
    isStartedDescription : "It will start automatically on {{date}}.",
    youDontHaveSubscripitionTitle : "You do not have an active subscription!",
    youDontHaveSubscripitionDescription : "By purchasing a membership, you can enjoy all the possibilities of OfficeLink.",


    // online sales

    minumumCharacterLimit : "Must be a minimum of {{number}} characters",
    maximumCharacterLimit : "Must be a maximum of {{number}} characters",

    // invoice

    totalPrice: "Amount",
    totalVatPrice: "Vat Amount",
    totalAmount: "Total Amount",
    total: "Total",
    paymentStatus: "Payment Status",
    dueDate: "Due Date",
    filter: "Filter",
    eInvoice: "E-invoice",
    invoiceType : "Invoice Type",
    Penalty : "Penalty Invoice",
    Sales : "Sales Invoice",


    Hourly: "Hourly",
    Daily: "Daily",
    Monthly: "Monthly",
    Yearly: "Yearly",
    Piece: "Piece",

    everyMonth: "Monthly",
    onceIn3Months: "Once In 3 Months",
    onceIn6Months: "Once In 6 Months",
    yearly: "Yearly",
    subscriptionDuration: "Contract Duration",
    areYouSureYouWantToDelete: "Are you sure you want to delete?",
    paymentAmount: "Payment Amount",
    subscriptionAmount: "Subscription Amount",
    subscriptionEndDate: "Subscription End Date",
    autoRenew: "Auto Renew?",
    addFile: "Add File",
    file: "File",
    online: "Online",
    offline: "Offline",
    invoiceView : "View Invoice",

    // webhook transaction
    webhooklogs : "Webhook Logs",
    transactionId : "Transaction Id",
    requestDate : "Time",
    endpoint : "Endpoint",
    httpMethod :  "Http Method",
    responseStatusCode : "Response Status Code",
    elapsedMiliseconds : "Processing time",
    companyUpdate : "company:update",
    companyGet : "company:get",
    companyGets : "company:gets",
    invoiceCreate : "invoice:create",
    invoiceGet : "invoice:get",
    invoicePaymentCreate : "invoice:payment:create",
    invoicePaymentDelete : "invoice:payment:delete"

  },
};

en.el = elementLocaleEN.el;

en.el.pagination.pagesize = "/ Page";

export default en;



// WEBPACK FOOTER //
// ./src/plugins/i18n/locales/en.js